module.exports = __webpack_public_path__ + "power_up.4c81cffa.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/power_up.png
// module id = 489
// module chunks = 0